import { render, staticRenderFns } from "./Quest.vue?vue&type=template&id=aca58e66"
import script from "./Quest.vue?vue&type=script&lang=ts"
export * from "./Quest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports